import React, { useEffect, useState } from "react";
import { http, BRAND } from "../lib/api";
import { X } from "lucide-react";

const FILTERS = [
  { id: "toate", label: "Toate" },
  { id: "coperti", label: "Coperți" },
  { id: "linii", label: "Pagini de colorat" },
  { id: "colorate", label: "Exemple colorate" },
  { id: "mockups", label: "Atmosferă" },
];

// Fallback if API returns empty
const FALLBACK = [
  { url: BRAND.cover, label: "Coperta VIS DE ZI", category: "coperti" },
  { url: BRAND.halloweenCover, label: "Coperta Ediția Halloween", category: "coperti" },
];

export default function GalleryPage() {
  const [active, setActive] = useState(null);
  const [filter, setFilter] = useState("toate");
  const [images, setImages] = useState([]);

  useEffect(() => {
    http.get("/gallery")
      .then((r) => setImages(Array.isArray(r.data) && r.data.length ? r.data : FALLBACK))
      .catch(() => setImages(FALLBACK));
  }, []);

  const filtered = filter === "toate" ? images : images.filter((i) => i.category === filter);

  return (
    <div className="py-16 md:py-24" data-testid="gallery-page">
      <div className="container-vdz">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="eyebrow mb-3">Galerie</div>
          <h1 className="font-serif-display text-5xl md:text-6xl" style={{ color: "var(--vdz-navy)" }}>Pagini din Vis de Zi.</h1>
          <p className="mt-5 opacity-75 leading-relaxed">
            Un preview al ilustrațiilor interior, al coperților și al momentelor cozy cu cartea.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center mb-10" data-testid="gallery-filters">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              data-testid={`gallery-filter-${f.id}`}
              className={`px-5 py-2 text-xs uppercase tracking-[0.2em] font-serif-accent border transition-all ${
                filter === f.id ? "bg-[color:var(--vdz-navy)] text-[color:var(--vdz-cream)] border-[color:var(--vdz-navy)]" : "bg-white text-[color:var(--vdz-navy)] border-[color:var(--vdz-cream-border)] hover:border-[color:var(--vdz-gold)]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-testid="gallery-grid">
          {filtered.map((img, i) => (
            <button
              key={`${img.id || img.url}-${i}`}
              onClick={() => setActive(img)}
              className="aspect-[3/4] overflow-hidden gold-frame bg-white group"
              data-testid={`gallery-image-${i}`}
            >
              <img src={img.url} alt={img.label || "Vis de Zi"} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
            </button>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-20 opacity-60">
            <p className="font-serif-display text-xl">Nicio imagine în această categorie încă.</p>
          </div>
        )}

        {active && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-6" style={{ background: "rgba(11,19,43,0.92)" }} onClick={() => setActive(null)} data-testid="gallery-lightbox">
            <button className="absolute top-6 right-6 text-white hover:text-[color:var(--vdz-gold)]" onClick={() => setActive(null)} aria-label="Închide">
              <X size={28} />
            </button>
            <div className="max-w-5xl w-full">
              <img src={active.url} alt={active.label || ""} className="max-h-[80vh] mx-auto object-contain" />
              {active.label && (
                <p className="text-center mt-4 text-sm font-serif-accent uppercase tracking-[0.22em] text-[color:var(--vdz-gold-pale)]">{active.label}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
